import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PaymentFailure.css';

const PaymentFailure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [failureMessage, setFailureMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const respCodeDesc = params.get("respCode_desc");
    const actionCodeDescription = params.get("actionCodeDescription");
    const ErrorCode = params.get("ErrorCode");
    const OrderStatus = params.get("OrderStatus");

    let message = "";

    if (respCodeDesc && respCodeDesc.trim() !== "") {
      message = respCodeDesc.trim();
    } else if (actionCodeDescription && actionCodeDescription.trim() !== "") {
      message = actionCodeDescription.trim();
    } else if (ErrorCode && ErrorCode !== "0") {
      message = "Le paiement a été refusé. Code erreur : " + ErrorCode;
    } else if (OrderStatus && OrderStatus !== "2") {
      message = "Le paiement n'a pas été finalisé (OrderStatus " + OrderStatus + ")";
    }

    setFailureMessage(message);
  }, [location]);

  const handleReturn = () => {
    navigate("/");
  };

  return (
    <div className="payment-failure-simple">
      <h1 className="failure-icon">❌ Paiement échoué</h1>
      {failureMessage && <p className="failure-message">{failureMessage}</p>}
      <p style={{ marginTop: "30px" }}>
        📞 En cas de problème de paiement, veuillez contacter le numéro vert de la SATIM : <strong>3020</strong>
      </p>
      <button onClick={handleReturn}>🏠 Retour à l'accueil</button>
    </div>
  );
};

export default PaymentFailure;
